// `/toast` has no flat `dist/toast.d.ts` — see index.tsx's import comment.
import { addToast } from '@clay-run/glaze/toast/index';
import { useLeadScannerStore, type IntakeRouteResult } from '../store';

/**
 * The impure half of `routeAfterIntake`'s decision (plan
 * plans/2026-08-26-001-lead-scanner-scans-page-plan.md) — the ONE place that
 * turns a `'multi'` intake result into rep-facing feedback, so that decision
 * lives in exactly one place instead of being copy-pasted into `Home.tsx`,
 * `PhotoIntake.tsx`, and `LinkedInQrScanner.tsx` (which is what happened
 * pre-Scans-page: each of those three called `completeIntake` and then fired
 * its own near-identical toast).
 *
 * - `'single'` — the store's `completeIntake` already applied `view` to open
 *   the review screen; there is nothing left to do here.
 * - `'multi'` — no single scan to open. Live-QA round-3 bug 1: this used to
 *   navigate to the Scans page; it no longer does — the rep stays on Home,
 *   and the store's `completeIntake` already recorded `intakeBatchIds` so
 *   Home's "New scans" list renders exactly these rows. All that's left
 *   here is the toast.
 * - `'none'` — defensive no-op.
 */
export function useCompleteIntake(): (ids: string[]) => IntakeRouteResult {
  const completeIntake = useLeadScannerStore((s) => s.completeIntake);

  return (ids: string[]) => {
    const result = completeIntake(ids);
    if (result.kind === 'multi') {
      addToast({ content: `${result.count} drafts created`, status: 'success' });
    }
    return result;
  };
}
